<script lang="ts">
import { defineBlock } from '@bagelink/blox'
import { defineSchema, $ } from '@bagelink/vue'
const defaults = {
	type: 'series',
	title: 'Series Title',
	image: '/og.jpg',
}
const schema = defineSchema({
	type: $.select('Type', [
		{ label: 'Series', value: 'series' },
		{ label: 'Symposium', value: 'symposium' },
	]),
	title: $.text('Title'),
	image: $.upload('Image'),
})
export const ArticleBanner = defineBlock({ pickerHidden: true, thumbnail: '/block-thumbs/ArticleBanner.svg', category: 'Legacy', order: 30, name: 'ArticleBanner', label: 'Article Banner (Legacy)', icon: 'flag', schema, defaults })
</script>
<script setup lang="ts">

import { Image } from '@bagelink/vue'
import { computed } from 'vue'
import { articleTitleText, sanitizeArticleTitleHtml } from '@/utils/articleHtml'




const props = withDefaults(defineProps<{
	type?: 'series' | 'symposium'
	title?: string
	image?: string
	link?: string
}>(), {
	type: 'series',
	image: '/og.jpg',
	link: '',
})

const typeLabel = props.type === 'series' ? 'Series' : 'Symposium'
const bannerLink = computed(() => props.link || `/${props.type === 'symposium' ? 'symposium' : 'series'}/`)
</script>

<template>
	<router-link :to="bannerLink" class="bg-gray p-075 w850px mt-1 flex gap-1 m_w-100p decoration-none color-black">
		<Image
			:src="image"
			:alt="articleTitleText(title)"
			ratio="2-1"
			class="ratio-2-1 h-120px m_none"
		/>
		<!-- Content -->
		<div class="txt-center w-100p">
			<p class="txt14 color-gray-70 pb-05 m_txt14">
				{{ typeLabel }}
			</p>
			<h3 class="txt24 m-0 regular m_txt20" v-html="sanitizeArticleTitleHtml(title)" />
		</div>
	</router-link>
</template>

<style scoped>

</style>
